import styled from 'styled-components';

import { colorTokens } from '../../../../../shared/components/variables';

const getColor = {
  late: {
    color: colorTokens.error.main,
  },
  early: {
    color: colorTokens.success.main,
  },
};

export const Tag = styled.span<{ $status: string }>`
  color: ${(props) => getColor[props.$status].color};
  border-radius: 4px;
  padding-left: 4px;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.15px;
`;
